
<template>
    <div style="margin-left:50px;">
  
      <el-form style="display: flex;flex-wrap: wrap;">
  
          <el-form-item label="问卷名称:" style="display: flex;width: 33%;">
              <el-select
                  placeholder="请选择问卷名称"
                  v-model="student"
                  style="width: 100%"
                  clearable
                  filterable>
                  <el-option
                  v-for="item in getStudentsArr"
                  :key="item.questionnaireId"
                  :value="item.questionnaireId"
                  :label="item.questionnaireTitle"
                  >
                  </el-option>
              </el-select>
              <!-- <el-input v-model="student" placeholder="请输入问卷名称"></el-input> -->
          </el-form-item>


          <el-form-item label="日期:" style="display: flex;width: 33%;"  label-width="75px">
              <el-date-picker
              style="width: 104%;margin-left: -139px;"
              v-model="dateTimeList"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              clearable>
              </el-date-picker>
          </el-form-item>
  
          <el-form-item label="创建人:" style="display: flex;width: 33%;" >
              <el-select
                  placeholder="请选择创建人"
                  v-model="student_s"
                  style="width: 100%"
                  clearable
                  filterable>
                  <el-option
                  v-for="item in getStudentsArr_s"
                  :key="item.id"
                  :value="item.id"
                  :label="item.realname"
                  >
                  </el-option>
              </el-select>
          </el-form-item>
  
          <!-- <el-form-item label="完成状态:" style="display: flex;width: 33%;" >
              <el-select
                  placeholder="请选择完成状态"
                  v-model="coursecancellationStatusInput"
                  style="width: 100%"
                  clearable
                  filterable >
                  <el-option
                  v-for="item in coursecancellationStatus"
                  :key="item.id"
                  :value="item.id"
                  :label="item.realname"
                  >
                  </el-option>
              </el-select>
          </el-form-item> -->
  
  
          <!-- <el-form-item label="分数:" style="display: flex;width: 33%;" >
              <el-select
                  placeholder="请选择分数"
                  v-model="coursecancellationStatusInput_s"
                  style="width: 100%"
                  clearable
                  filterable >
                  <el-option
                  v-for="item in coursecancellationStatus"
                  :key="item.id"
                  :value="item.id"
                  :label="item.realname"
                  >
                  </el-option>
              </el-select>
              <el-input v-model="coursecancellationStatusInput_s" placeholder="请输入分数"></el-input>
          </el-form-item> -->
  
          <!-- <el-form-item label="参训人完成状态:" style="display: flex;width: 33%;" >
              <el-select
                  placeholder="请选择参训人完成状态"
                  v-model="coursecancellationStatusInput_ss"
                  style="width: 100%"
                  clearable
                  filterable >
                  <el-option
                  v-for="item in coursecancellationStatus"
                  :key="item.id"
                  :value="item.id"
                  :label="item.realname"
                  >
                  </el-option>
              </el-select>
          </el-form-item> -->
  
          
          <div style="display: flex;justify-content: end;width: 100%;margin-top: 10px;margin-bottom: 30px;">
               <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-plus" @click="AddexportBtnss">添加考试问卷</el-button>
               <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-plus" @click="AddexportBtns">添加问卷</el-button>
               <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns">搜索</el-button>
               <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns">清空</el-button>
               <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-download" @click="exportBtns">导出</el-button>
          </div>
  
      </el-form>
  
  
      <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" :data="dataList" border height="550">
          <el-table-column prop="createTime" label="日期">
            <!-- <template slot-scope="scope">
               <span>{{scope.row.courseDate.substring(0,10)}}</span>
            </template> -->
          </el-table-column>
          <el-table-column prop="questionnaireTitle" label="问卷名称"></el-table-column>
          <el-table-column prop="creatorName" label="创建人"></el-table-column>
          <!-- <el-table-column prop="subjectName" label="完成状态"></el-table-column> -->
          <!-- <el-table-column prop="subjectName" label="分数"></el-table-column> -->
          <el-table-column label="操作">
              <template slot-scope="scope">
                <div style="display: flex;justify-content: space-around;">
                  <el-button type="text" style="color:#00aaff;" @click="handleClickView('编辑', scope.row)">编辑</el-button>
                  <el-button type="text" style="color:#00aaff;" @click="handleClickView('详情', scope.row)">详情</el-button>
                </div>
              </template>
          </el-table-column>
        </el-table>
  
  
  
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="requestParameters.pageNum" :page-size="requestParameters.pageSize"
        layout="prev, pager, next,sizes, jumper" :total="requestParameters.total">
      </el-pagination>
  
  
  
      <el-dialog :title="ShowDlongTitle" :visible.sync="ShowDlong" :before-close="commitCler">
          
          <el-form ref="form" :model="form" label-width="80px">
  
              <el-form-item label="方案内容:" style="text-align: start;">
                  <div style="text-align: start;">{{form.student}}</div>
              </el-form-item>
              <el-divider></el-divider>
  
              <el-form-item label="提交人:" style="text-align: start;">
                 <div style="text-align: start;">{{form.student_s}}</div>
              </el-form-item>
              <el-divider></el-divider>
  
             <el-form-item label="相关资料:" style="text-align: start;">
              <div style="text-align: start;height: 47px; overflow-x: auto;">
                  <a style="margin-right: 10px;" v-for="(itme,index) in form.coursecancellationStatusInput" :key="index" :href="itme.url">{{ itme.name }}</a>
              </div>
             </el-form-item>
             <el-divider></el-divider>
  
             <el-form-item label="提交日期:" style="text-align: start;">
                 <div style="text-align: start;">{{form.dateTimeList}}</div>
             </el-form-item>
             <el-divider></el-divider>
  
  
          </el-form>
  
  
          <div slot="footer" class="dialog-footer">
            <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-error" @click="commitCler">取消</el-button>
            <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-success" type="primary" @click="commitAdd('No')">驳回</el-button>
            <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-success" type="primary" @click="commitAdd('Yes')">通过</el-button>
          </div>
  
      </el-dialog>
      
  
  
      <el-dialog title="添加培训任务" style="padding: 0px 10px;" :visible.sync="AddShowDlong" :before-close="AddcommitCler" :close-on-click-modal="false">
          
          <el-form ref="form" :model="form" label-width="100px">
  
              <el-form-item label="培训名称:">
                  <el-input placeholder="请选择培训名称" v-model="Addform.TrainName" style="width: 100%" clearable> 
                  </el-input>
              </el-form-item>
  
              <el-form-item label="任务创建人:">
                <el-select
                  placeholder="请选任务创建人"
                  v-model="Addform.CreatorName"
                  style="width: 100%"
                  clearable
                  filterable>
                  <el-option
                      v-for="item in getStudentsArr_s"
                      :key="item.id"
                      :value="item.id"
                      :label="item.realname">
                  </el-option>
              </el-select>
              </el-form-item>
  
             <el-form-item label="参加培训人:">
              <el-select
                  placeholder="请选择参加培训人"
                  v-model="Addform.TrainerName"
                  style="width: 100%"
                  clearable
                  filterable>
                   <el-option
                       v-for="item in coursecancellationStatus"
                       :key="item.id"
                       :value="item.id"
                       :label="item.realname" >
                   </el-option>
              </el-select>
             </el-form-item>
  
             <el-form-item label="培训内容:">
                  <div style="width: 100%;height: 250px;overflow-x: auto;display: flex;">
                      <el-radio  @click="clickitem(item.id)" border v-model="Addform.TrainingContent"
                           style="width: 130px; height: 100%;" v-for="(item, index) in planArr" :key="index" :label='item.id'>
                          <h3 style="margin-top: 0px;">{{ item.planName }}</h3>
                          <div style="text-align: left;"  v-for="(item1, index1) in item.planList" :key="index1">
                              <p>课节数:{{ item1.classNum }}</p>
                              <p style="margin-bottom: 20px;">课时单价:{{ item1.classPrice }}</p>
                          </div>
                      </el-radio>
                  </div>
             </el-form-item>
  
             <el-form-item label="资料上传:">
                  <el-upload
                      class="upload-demo"
                      drag
                      action="#"
                      :on-remove="handleRemove"
                      :beforeUpload="beforeUpload"
                      :http-request="handleUpload"
                      :on-error="handleError"
                      :auto-upload="true"
                      show-file-list
                      :file-list="fileDataList"
                      multiple>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  </el-upload>
             </el-form-item>   
  
             <el-form-item label="审批人:">
                  <el-select
                      placeholder="请选择审批人"
                      v-model="Addform.ApprovedName"
                      style="width: 100%"
                      clearable
                      filterable >
                      <el-option
                          v-for="item in coursecancellationStatus"
                          :key="item.id"
                          :value="item.id"
                          :label="item.realname" >
                      </el-option>
                  </el-select>
             </el-form-item>
  
  
          </el-form>
  
  
          <div slot="footer" class="dialog-footer">
            <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-error" @click="AddcommitCler">取消</el-button>
            <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-plus" @click="AddcommitSub">保存</el-button>
            <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-success" type="primary" @click="AddcommitAdd">提交</el-button>
          </div>
  
      </el-dialog>
  
  
  
      <el-dialog title="审批意见" style="padding: 0px 10px;" :visible.sync="ShowapprovalOpinions" :before-close="approvalOpinionsCler">
          <el-input :autosize="{  minRows: 6, maxRows: 6 }"  type="textarea"  placeholder="请输入驳回内容"  v-model="approvalOpinionstextarea" maxlength="200" show-word-limit></el-input>
      
          <div slot="footer" class="dialog-footer">
            <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-success" type="primary" @click="AddapprovalOpinions">确定</el-button>
          </div>
  
      </el-dialog>
  
  
      <el-dialog title="审批意见" style="padding: 0px 10px;" width="30%" :visible.sync="ShowapprovalOpinions_Yes" :before-close="approvalOpinionsCler_Yes">
          
          <div style="">是否提交审批意见?</div>
  
          <div slot="footer" class="dialog-footer" style="text-align: center;">
            <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-error" @click="approvalOpinionsCler_Yes">取消</el-button>
            <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-success" type="primary" @click="AddapprovalOpinions_Yes">确定</el-button>
          </div>
  
      </el-dialog>
  
      

      <el-dialog title="添加问卷" style="padding: 0px 10px;" width="85%" :visible.sync="showQuestionnaireDialog" :before-close="showQuestionnaireDialogCler" :close-on-click-modal="false">
          
        <el-row :class="ShowDlongTitle === '方案名称详情' ? 'no-click' : '' ">
            <el-col :span="4">
                <div style="margin-left: -30px;">
                    <span>创建人:</span>
                    <span>{{adminName}}</span>
                </div>
            </el-col>
            <el-col :span="15" style="display: flex;justify-content: space-evenly;">
                <div style="">
                    <span>日期:</span>
                    <span>{{currentTime}}</span>
                </div>
                <div style="display: flex;margin-top: -10px;">
                    <span style="padding-top: 10px;margin-left: -63px;margin-right: 8px;">答题次数:</span>
                    <span><el-input v-model="inputAnswering" maxlength="2" placeholder="请输入答题次数"></el-input></span>
                </div>
            </el-col>
            <el-col :span="5">
                <div style="">
                    <span>总分数:</span>
                    <span>单选分值+多选分+自由题</span>
                </div>
            </el-col>
        </el-row>


        <el-row style="margin: 20px 0px;" :class="ShowDlongTitle === '方案名称详情' ? 'no-click' : '' ">
            <el-col :span="24">
                <div style="display: flex;justify-content: start;margin-left: 43px;">
                    <div style="padding-top: 10px;">问卷标题:</div>
                    <div style="margin-left: 10px;">
                        <el-input style="width: 600px;" v-model="inputQuestionnaireTitle" @blur="handleBlurInputQuestionnaireTitle"	 placeholder="请输入问卷标题"></el-input>
                    </div>
                </div>
            </el-col>
        </el-row>



       <div style="margin-left: 43px;margin-top: 50px;margin-bottom: 20px;" :class="ShowDlongTitle === '方案名称详情' ? 'no-click' : '' ">    
            <div style="display: flex;">
                <div style="width: 50px;">单选题:</div>
                <div style="width: 100%;height: 310px;overflow-y: auto;">

                    <el-card style="height: 300px;width: 95%;border-radius: 20px;margin-left: 23px;margin-top: 10px;margin-right: 12px;" v-for="(itme,index) in questionnaireAnswers.singleChoiceList" :key="index">
                            
                             <div style="display: flex;">
                                <div style="padding-top: 10px;">题目{{ index == 0 ? '一' : index === 1 ? '二' : index === 2 ? '三' : index === 3 ? '四' : index === 4 ? '五' :
                                    index == 5 ? '六' : index === 6 ? '七' : index == 7 ? '八' : index === 8 ? '九' : index === 9 ? '十' :
                                    index == 10 ? '十一' : index == 11 ? '十二' : index == 12 ? '十三' : index == 13 ? '十四' : index == 14 ? '十五' :
                                    index == 15 ? '十六' : index == 16 ? '十七' : index === 17 ? '十八' : index === 18 ? '十九' : index === 20 ? '二十' :
                                    index == 21 ? '二十一' : index === 22 ? '二十二' : index == 23 ? '二十四' : index == 24 ? '二十五' : index === 25 ? '二十六' :
                                    index === 27 ? '二十八' : index === 28 ? '二十九' : index == 29 ? '三十' : '三十一' }}:</div>
                                <div style="margin-left: 10px;">
                                    <el-input v-model="itme.questionTitle" style="width: 450px;" placeholder="请输入题目"></el-input>
                                </div>
                                <div style="margin-left: 10px;">
                                    <el-input v-model="itme.score" maxlength="2" style="width: 120px;" placeholder="请输入分值"></el-input>
                                </div>   
                                <div style="margin-left: 10px;">
                                    <el-input v-model="itme.answer" maxlength="1" style="width: 120px;" placeholder="请输入答案"></el-input>
                                </div>
                                <div style="margin-left:20px;">
                                    <div style="font-size: 26px;padding-top: 1px; display: flex;">
                                        <i class="el-icon-circle-plus-outline" @click="handleMultipleChoiceQuestionAdd"></i>
                                        <i class="el-icon-remove-outline" @click="handleMultipleChoiceQuestionReduce(index)"></i>
                                    </div>
                                </div>  
                             </div>


                             <div style="display: flex;margin-left: 40px;margin-top: 30px;height: 160px;">
                                <div style="width: 90%;display: flex;flex-wrap: wrap;overflow: auto;height: 150px;">
                                    <div style="display: flex;margin-bottom: 14px;" v-for="(itmesm,indexs) in itme.questionContent" :key="indexs">
                                        <div style="width: 45px;margin-right: 10px;margin-left: 20px;">
                                            <el-input :maxlength="1" v-model="itmesm.inputOption" ></el-input> 
                                        </div>
                                        <div>
                                            <el-input v-model="itmesm.inputValue"></el-input> 
                                        </div>
                                    </div>
                                </div>
                                <div style="margin-left:20px;">
                                    <div style="font-size: 26px;padding-top: 1px; display: flex;">
                                        <i class="el-icon-circle-plus-outline" @click="handleMultipleChoiceQuestionType('PlusSign',index)"></i>
                                        <i class="el-icon-remove-outline" @click="handleMultipleChoiceQuestionType('MinusSign',index)"></i>
                                    </div>
                                </div> 
                            </div>

                            <div style="margin: 15px 0px 0px 66px;display: flex;">
                                <div style="padding-top: 2px;">是否展示正确答案</div>
                                <div style="margin-left: 20px;padding-top: 4px;">
                                    <el-radio v-model="itme.isDisplayAnswers" label="0">否</el-radio>
                                    <el-radio v-model="itme.isDisplayAnswers" label="1">是</el-radio>
                                </div>
                            </div>

                    </el-card>

                </div>
            </div>
       </div>     



       <div style="margin-left: 43px;margin-top: 50px;margin-bottom: 20px;" :class="ShowDlongTitle === '方案名称详情' ? 'no-click' : '' ">    
            <div style="display: flex;">
                <div style="width: 50px;">多选题:</div>
                <div style="width: 100%;height: 310px;overflow-y: auto;">

                    <el-card style="height: 300px;width: 95%;border-radius: 20px;margin-left: 23px;margin-top: 10px;margin-right: 12px;" v-for="(itme,index) in questionnaireAnswers.multipleChoiceList" :key="index">
                            
                             <div style="display: flex;">
                                <div style="padding-top: 10px;">题目{{index == 0 ? '一' : index === 1 ? '二' : index === 2 ? '三' : index === 3 ? '四' : index === 4 ? '五' :
                                    index == 5 ? '六' : index === 6 ? '七' : index == 7 ? '八' : index === 8 ? '九' : index === 9 ? '十' :
                                    index == 10 ? '十一' : index == 11 ? '十二' : index == 12 ? '十三' : index == 13 ? '十四' : index == 14 ? '十五' :
                                    index == 15 ? '十六' : index == 16 ? '十七' : index === 17 ? '十八' : index === 18 ? '十九' : index === 20 ? '二十' :
                                    index == 21 ? '二十一' : index === 22 ? '二十二' : index == 23 ? '二十四' : index == 24 ? '二十五' : index === 25 ? '二十六' :
                                    index === 27 ? '二十八' : index === 28 ? '二十九' : index == 29 ? '三十' : '三十一'}}:</div>
                                <div style="margin-left: 10px;">
                                    <el-input v-model="itme.questionTitle" style="width: 450px;" placeholder="请输入题目"></el-input>
                                </div>
                                <div style="margin-left: 10px;">
                                    <el-input v-model="itme.score" maxlength="2" style="width: 120px;" placeholder="请输入分值"></el-input>
                                </div>   
                                <div style="margin-left: 10px;">
                                    <el-input v-model="itme.answer" maxlength="8" style="width: 120px;" placeholder="请输入答案"></el-input>
                                </div>
                                <div style="margin-left:20px;">
                                    <div style="font-size: 26px;padding-top: 1px; display: flex;">
                                        <i class="el-icon-circle-plus-outline" @click="handleMultipleChoiceQuestionsAdd"></i>
                                        <i class="el-icon-remove-outline" @click="handleMultipleChoiceQuestionsReduce(index)"></i>
                                    </div>
                                </div>  
                             </div>


                             <div style="display: flex;margin-left: 40px;margin-top: 30px;height: 160px;">
                                <div style="width: 90%;display: flex;flex-wrap: wrap;overflow: auto;height: 150px;">
                                    <div style="display: flex;margin-bottom: 14px;" v-for="(itmesm,indexs) in itme.questionContent" :key="indexs">
                                        <div style="width: 45px;margin-right: 10px;margin-left: 20px;">
                                            <el-input :maxlength="1" v-model="itmesm.inputOption" ></el-input> 
                                        </div>
                                        <div>
                                            <el-input v-model="itmesm.inputValue"></el-input> 
                                        </div>
                                    </div>
                                </div>
                                <div style="margin-left:20px;">
                                    <div style="font-size: 26px;padding-top: 1px; display: flex;">
                                        <i class="el-icon-circle-plus-outline" @click="handleMultipleChoiceQuestionsType('PlusSign',index)"></i>
                                        <i class="el-icon-remove-outline" @click="handleMultipleChoiceQuestionsType('MinusSign',index)"></i>
                                    </div>
                                </div> 
                            </div>

                            <div style="margin: 15px 0px 0px 66px;display: flex;">
                                <div style="padding-top: 2px;">是否展示正确答案</div>
                                <div style="margin-left: 20px;padding-top: 4px;">
                                    <el-radio v-model="itme.isDisplayAnswers" label="0">否</el-radio>
                                    <el-radio v-model="itme.isDisplayAnswers" label="1">是</el-radio>
                                </div>
                            </div>

                    </el-card>

                </div>
            </div>
       </div>  



       
       <div style="margin-left: 43px;margin-top: 50px; margin-bottom: 30px;" :class="ShowDlongTitle === '方案名称详情' ? 'no-click' : '' ">    
            <div style="display: flex;">
                <div style="width: 50px;">简答题:</div>
                <div style="width: 100%;height: 310px;overflow-y: auto;">

                    <el-card style="height: 300px;width: 95%;border-radius: 20px;margin-left: 23px;margin-top: 10px;margin-right: 12px;" v-for="(itme,index) in questionnaireAnswers.shortAnswerList" :key="index">
                            
                             <div style="display: flex;">
                                <div style="padding-top: 10px;">题目{{ index == 0 ? '一' : index === 1 ? '二' : index === 2 ? '三' : index === 3 ? '四' : index === 4 ? '五' :
                                    index == 5 ? '六' : index === 6 ? '七' : index == 7 ? '八' : index === 8 ? '九' : index === 9 ? '十' :
                                    index == 10 ? '十一' : index == 11 ? '十二' : index == 12 ? '十三' : index == 13 ? '十四' : index == 14 ? '十五' :
                                    index == 15 ? '十六' : index == 16 ? '十七' : index === 17 ? '十八' : index === 18 ? '十九' : index === 20 ? '二十' :
                                    index == 21 ? '二十一' : index === 22 ? '二十二' : index == 23 ? '二十四' : index == 24 ? '二十五' : index === 25 ? '二十六' :
                                    index === 27 ? '二十八' : index === 28 ? '二十九' : index == 29 ? '三十' : '三十一' }}:</div>
                                <div style="margin-left: 10px;">
                                    <el-input v-model="itme.questionTitle" style="width: 450px;" placeholder="请输入题目"></el-input>
                                </div>
                                <div style="margin-left: 10px;">
                                    <el-input v-model="itme.score" style="width: 120px;" placeholder="请输入分值"></el-input>
                                </div>   
                                <div style="margin-left:20px;">
                                    <div style="font-size: 26px;padding-top: 1px; display: flex;">
                                        <i class="el-icon-circle-plus-outline" @click="handleFreeformQuestionsAdd"></i>
                                        <i class="el-icon-remove-outline" @click="handleFreeformQuestionsReduce(index)"></i>
                                    </div>
                                </div>  
                             </div>

                            <div style="display: flex;margin-left: 40px;margin-top: 30px;height: 160px;">
                                <div style="width: 90%;display: flex;flex-wrap: wrap;overflow: auto;height: 150px;">
                                    <div style="display: flex;margin-bottom: 14px;width: 98%;" v-for="(itmesm,indexs) in itme.questionContent" :key="indexs">
                                        <div style="display: flex;width: 100%;margin-left: 15px;">
                                            <div style="width: 100%;">
                                                <el-input resize="none" style="width: 100%;" type="textarea" :autosize="{ minRows: 6, maxRows: 6 }" maxlength="300" show-word-limit v-model="itmesm.answer" placeholder="请输入简答题答案"></el-input> 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                              <!---  <div style="margin-left:20px;">
                                    <div style="font-size: 26px;padding-top: 1px; display: flex;">
                                        <i class="el-icon-circle-plus-outline" @click="handleFreeformQuestionsType('PlusSign',index)"></i>
                                        <i class="el-icon-remove-outline" @click="handleFreeformQuestionsType('MinusSign',index)"></i>
                                    </div>
                                </div> 
                               -->
                            </div>


                            <div style="margin: 15px 0px 0px 66px;display: flex;">
                                <div style="padding-top: 2px;">是否展示正确答案</div>
                                <div style="margin-left: 20px;padding-top: 4px;">
                                    <el-radio v-model="itme.isDisplayAnswers" label="0">否</el-radio>
                                    <el-radio v-model="itme.isDisplayAnswers" label="1">是</el-radio>
                                </div>
                            </div>

                    </el-card>

                </div>
            </div>
       </div>      



  
        <div slot="footer" class="dialog-footer" style="text-align: center;">
          <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-error" @click="showQuestionnaireDialogCler">取消</el-button>
          <el-button v-if="ShowDlongTitle !== '方案名称详情'" style="height: 30px;"  size="small" class="btns" icon="el-icon-success" type="primary" @click="showQuestionnaireDialogAdd">提交</el-button>
        </div>
  
      </el-dialog>
  


      <div class="box"  v-if="AddexportBtnssShow">
        
        <div style="border: 1px solid #EBEEF5; background-color: #FFF;border-radius: 10px;margin-left: 10px;margin-right: 4px;">
            <div style="text-align: end; padding-right: 20px; padding-top: 10px; font-size: 26px;" @click="AddexportBtnssShowCler"><i class="el-icon-close"></i> </div>
            <div style="font-size:20px;font-weight: 900;margin-bottom: 10px;margin-bottom:20px;">添加考试信息</div>

            <el-row style="margin-bottom: 10px;"  :class="ShowDlongTitle === '方案名称详情' ? 'no-click' : '' ">
                <el-col :span="6">
                    <div style="margin-left: -30px;">
                        <span>创建人:</span>
                        <span>{{adminName}}</span>
                    </div>
                </el-col>
                <el-col :span="6" style="display: flex;justify-content: space-evenly;">
                    <div style="display: flex;margin-top: -10px;">
                        <span style="padding-top: 10px;margin-left: -63px;margin-right: 8px;">答题次数:</span>
                        <span><el-input v-model="inputAnswering" maxlength="2" placeholder="请输入答题次数"></el-input></span>
                    </div>
                </el-col>
                <el-col :span="10">
                    <div style="display: flex;justify-content: start;margin-left: 43px;">
                        <div style="width:100px;">问卷标题:</div>
                        <div style="margin-left: 10px;margin-top: -8px;">
                            <el-input style="width:400px;" v-model="inputQuestionnaireTitle" placeholder="请输入问卷标题"></el-input>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>


        <div style="display: flex;margin-top: 10px;">
            <div style="width:18%;height: 750px; border: 1px solid #EBEEF5; background-color: #FFF;border-radius: 10px; margin-right: 10px; margin-left: 10px;">
                <div style="width: 100%;display: flex;flex-wrap: wrap;"  :class="ShowDlongTitle === '方案名称详情' ? 'no-click' : '' ">
                    <div class="actdiv" style="width: 50%;margin-top: 10px;"  @click="handleAddAnswers">多项填空</div>
                </div>
            </div>
            <div style="width:80%;height: 750px;border: 1px solid #EBEEF5; background-color: #FFF;border-radius: 10px;overflow: auto;">

                <el-card style="height: 650px;width: 95%;border-radius: 20px;margin-left: 23px;margin-top: 10px;margin-right: 12px;" v-for="(itme,index) in completionList" :key="index">
                    <div style="margin-left:20px;">
                        <div style="font-size: 26px;padding-top: 1px;text-align: end; width: 100%;"   :class="ShowDlongTitle === '方案名称详情' ? 'no-click' : '' ">
                            <i class="el-icon-remove-outline" @click="handleFreeformQuestionsReduce(index,'completionList')"></i>
                        </div>
                    </div> 

                    <div style="text-align: start;margin-left: 53px;">
                        <el-input style="width:400px;" v-model="itme.vacancyTitle" placeholder="请输入标题"></el-input>
                        <el-button  class="btns" @click="handleClickBtn(itme,index)">导入图片</el-button>
                    </div>

                    <div v-if="itme.imgUrl"  style="display: flex;width: 93%; text-align: start;  margin-left: 53px;  height: 50px;  padding-top: 10px;  overflow: auto; border: 1px solid #ddd6d6; margin-top: 10px;padding-left: 10px;" > 
                         <div v-for="(itmes,indexs) in itme.imgUrl" :key="indexs" style="display: flex;">
                            <a style="margin-left: 20px;" :href="itmes.url">{{itmes.name}}</a>
                            <i class="el-icon-close" style="margin-left: 10px; margin-top: 3px;" v-if="itmes.url" @click="handleClr(itmes,indexs,index)"></i>
                         </div>
                    </div>

                    <div style="display: flex;margin-left: 40px;margin-top: 30px;height: 160px;"  :class="ShowDlongTitle === '方案名称详情' ? 'no-click' : '' ">
                        <div style="width: 90%;display: flex;flex-wrap: wrap;height: 150px;">
                            <div style="display: flex;margin-bottom: 14px;width: 98%;">
                                <div style="display: flex;width: 100%;margin-left: 15px;">
                                    <div style="width: 100%;">
                                        <el-input resize="none" style="width: 100%;" type="textarea" :autosize="{ minRows: 9, maxRows: 9 }" 
                                        maxlength="1000" show-word-limit v-model="itme.questionTitle" placeholder="请输入多项填空"></el-input> 
                                        <div style="display: flex;"  v-if="ShowDlongTitle !== '方案名称详情'">
                                            <div style="margin-top: 10px;width: 77px;background-color:#428BCA;color: #fff;padding: 5px;border-radius: 5px;line-height: 29px;" @click="handleAddAnswer(index)">新增答案</div>
                                            <div style="margin-top: 10px;width: 77px;background-color:#428BCA;color: #fff;padding: 5px;border-radius: 5px;line-height: 29px; margin-left: 10px;" @click="handleAddAnswer(index,'删除')">删除答案</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                   <div style="display: flex;flex-wrap: wrap;margin-top: 100px; height: 150px; overflow: auto;margin-left: 43px;"  :class="ShowDlongTitle === '方案名称详情' ? 'no-click' : '' ">
                        <div style="display: flex;"  v-for="(itmes,indexs) in itme.answer" :key="indexs">
                            <div style="margin-left: 10px;margin-top: 10px;">
                                答案：<el-input v-model="itmes.vacancyAnswer"  style="width: 255px;" placeholder="请输入填空答案"></el-input>
                            </div> 
                            <div style="margin-left: 10px;margin-top: 10px;">
                                分值：<el-input v-model="itmes.vacancyScore" :maxlength="3" style="width: 120px;" placeholder="请输入分值"></el-input>
                            </div> 
                        </div>
                   </div>
                </el-card>

            </div>
        </div>

        <div slot="footer" class="dialog-footer" style="position: fixed;bottom: 35px;right: 65px;">
          <el-button v-if="ShowDlongTitle !== '方案名称详情'" style="height: 30px;"  size="small" class="btns" icon="el-icon-plus" @click="AddexportBtnssShowAdd">提交</el-button>
        </div>

      </div>



      <el-dialog title="导入图片" style="padding: 0px 10px;" :visible.sync="showImg" :before-close="showImgClr">
        <el-upload
           class="upload-demo"
           drag
           action="#"
           :on-remove="handleRemove"
           :beforeUpload="beforeUpload"
           :http-request="handleUpload"
           :on-error="handleError"
           :auto-upload="true"
           show-file-list
           :file-list="fileDataList"
           multiple>
           <i class="el-icon-upload"></i>
           <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
       </el-upload>
         <div slot="footer" class="dialog-footer">
           <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-plus" @click="showImgAdd">提交</el-button>
         </div>
      </el-dialog>

  
  </div>
</template>
  
<script>
  import axios from "axios";
  import apiBaseUrl from "../../config/api";
  import Vue from 'vue';
  import { ref, reactive, onMounted, defineComponent, toRefs, nextTick, onUpdated, watchEffect } from '@vue/composition-api'
  var $Vue = Vue.prototype
  import {  getStudentsType } from "@/api/fiveClassApi"
  import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
  import loadingUtils from "../utils/loading";
  import { isReturn } from "../utils/retnue";
  
  export default defineComponent({
  
      setup(props, { attrs, slots, emit, expose }){
          let showImg = ref(false)
          let clickImgIndex = ref(0)
          let inputAnswering = ref('')
          let approvalOpinionstextarea = ref('')
          let ShowapprovalOpinions = ref(false)
          let getStudentsArr = ref([])
          let getStudentsArr_s = ref([])
          let coursecancellationStatus = ref([])
          let student = ref('')
          let student_s = ref('')
          let coursecancellationStatusInput = ref('')
          let coursecancellationStatusInput_s = ref('')
          let coursecancellationStatusInput_ss = ref('')
          let dateTimeList = ref([])
          let dataList = ref([])
          let requestParameters = reactive({pageSize:10,total:0,pageNum:1})
          let ShowDlong = ref(false)
          let ShowDlongDisabled = ref(false)
          let ShowDlongTitle = ref('编辑')
          let form = reactive({ student:'', student_s: '', coursecancellationStatusInput:[], dateTimeList: '' })
          let AddShowDlong = ref(false)
          let Addform = reactive({ TrainName:'', CreatorName:'', TrainerName: '', TrainingContent:'', DataUpload: '', ApprovedName: '' })
          let planArr = ref([])
          let fileDataList = ref([])
          let ShowapprovalOpinions_Yes = ref(false)
          let currentTime = ref('')
          let showQuestionnaireDialog = ref(false)
          let adminName = ref('')
          let inputQuestionnaireTitle = ref('')
          let questionTitle = ref('')
          let score = ref('')
          let inputAnswer = ref('')
          let adminNameID = ref('')
          let questionnaireAnswers = reactive({ singleChoiceList:[{ questionContent:[{ inputValue:'',inputOption:'' }] }], multipleChoiceList:[{ questionContent:[{ inputValue:'',inputOption:'' }] }], shortAnswerList:[{ questionContent:[{ inputValue:''}]}] })
          let AddexportBtnssShow = ref(false)
          let completionList = ref([{ questionTitle:'', answer:[] }])
          let edibleRow = ref({})

          onMounted(()=>{
              handleCurrentTime()
              handleAllApi()
              let admin = JSON.parse(localStorage.getItem('admin'))
              adminName.value = admin.realname
              adminNameID.value = admin.id
          })
  
          watchEffect(() => {
              console.log(`Count is now 让子弹飞一会`);
          })
          
          const handleCurrentTime = () =>{
            const currentDate = new Date();
            const year = currentDate.getFullYear();
            const month = currentDate.getMonth() + 1; 
            const day = currentDate.getDate();
            let newTime = `${year}/${month < 10 ? '0' + month : month }/${day < 10 ? '0' + day : day }`
            currentTime.value = newTime
          }
          
          const handleAllApi = () =>{
              getStudentsArr.value = [{ id: 1, realname : '李四' },{ id: 2, realname : '张三' },{ id: 3, realname : '王五' }]
              getStudentsArr_s.value = [{ id: 1, realname : '颇多野' },{ id: 2, realname : '梅川合' },{ id: 3, realname : '拖一大' }]
              coursecancellationStatus.value = [{ id: 1, realname : '未完成' },{ id: 2, realname : '已完成' }]
            //   dataList.value = [{ courseDate: '2024-01-14', courseStartTime: '张三', courseEndTime: '颇多野', subjectName: [{url:'https:baidu.com',name:'虚拟图片'},{url:'https:baidu.com',name:'虚拟图片2'}]  }]

              axios.get(`${apiBaseUrl}/questionnaire/queryCreator`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },
                }).then(res => {
                    isReturn(res.code)
                    getStudentsArr_s.value = res.data.data
                }).catch(error => {
                    console.error(error)
              })


              axios.get(`${apiBaseUrl}/questionnaire/queryTitle`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },
                }).then(res => {
                    isReturn(res.code)
                    getStudentsArr.value = res.data.data
                }).catch(error => {
                    console.error(error)
              })



              let data = {
                    pageNo: requestParameters.pageNum,
                    pageSize: requestParameters.pageSize,
                    creatorId: student_s.value,
                    questionnaireId : student.value,
                    startTime: `${dateTimeList.value[0] ? dateTimeList.value[0]: '' }`,
                    endTime:  `${dateTimeList.value[1] ? dateTimeList.value[1]: '' }`,
              }
              axios.post(`${apiBaseUrl}/questionnaire/queryQuestionnaire`, data,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }, }).then(res => {
                  isReturn(res.code)
                  if(res.data.code == 200){
                     handleMessage("查询成功", 'success')
                  }
                  dataList.value = res.data.data.page.records
                  requestParameters.pageNum = res.data.data.page.current
                  requestParameters.pageSize = res.data.data.page.size
                  requestParameters.total = res.data.data.page.total
              }).catch(error => {
                  console.error(error)
              })


              axios.post(`${apiBaseUrl}/contract/getList`, requestParameters,{
                  headers:{
                      'authorization': sessionStorage.getItem('tokenInfo')
                  },
              }).then(res => {
                  isReturn(res.code)
                  planArr.value = res.data.data.records
              }).catch(error => {
                  console.error(error)
              })
          }
  
          const handleMessage = (message,type) =>{
               $Vue.$message({ message, type, duration: 500 });
          }
  
          const approvalOpinionsCler = ()=>{
              approvalOpinionstextarea.value = ''
              ShowapprovalOpinions.value = false
              ShowDlong.value = true
              let detailsInfo = JSON.parse(sessionStorage.getItem('detailsInfo'))
              if(detailsInfo){
                 form.student = detailsInfo.student
                 form.student_s = detailsInfo.student_s
                 form.coursecancellationStatusInput = detailsInfo.coursecancellationStatusInput
                 form.dateTimeList = detailsInfo.dateTimeList
              }
          }
  
          const exportBtns = () =>{
            let data = {
                    creatorId: student_s.value,
                    questionnaireId : student.value,
                    startTime: `${dateTimeList.value[0] ? dateTimeList.value[0]: '' }`,
                    endTime:  `${dateTimeList.value[1] ? dateTimeList.value[1]: '' }`,
            }
            axios.post(`${apiBaseUrl}/questionnaire/excelQuestionnaire`, data, { responseType: "blob", headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
                if(response.status == 200){
                    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
                    const downloadLink = document.createElement("a");
                    downloadLink.href = URL.createObjectURL(blob);
                    downloadLink.download = "问卷模板.xlsx"; 
                    downloadLink.click();
                    handleMessage('导出成功', 'success')
                }
                else{
                    handleMessage('导出失败', 'error')
                }
            })
          }
          const searchBtns = () =>{
            let data = {
                    pageNo: requestParameters.pageNum,
                    pageSize: requestParameters.pageSize,
                    creatorId: student_s.value,
                    questionnaireId : student.value,
                    startTime: `${dateTimeList.value[0] ? dateTimeList.value[0]: '' }`,
                    endTime:  `${dateTimeList.value[1] ? dateTimeList.value[1]: '' }`,
              }
              axios.post(`${apiBaseUrl}/questionnaire/queryQuestionnaire`, data,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }, }).then(res => {
                  isReturn(res.code)
                  if(res.data.code == 200){
                     handleMessage("查询成功", 'success')
                  }
                  dataList.value = res.data.data.page.records
                  requestParameters.pageNum = res.data.data.page.current
                  requestParameters.pageSize = res.data.data.page.size
                  requestParameters.total = res.data.data.page.total
              }).catch(error => {
                  console.error(error)
              })
          }
          const clearBtns = () =>{
              student.value = ""
              student_s.value = ""
              coursecancellationStatusInput.value = ""
              coursecancellationStatusInput_s.value = ""
              coursecancellationStatusInput_ss.value = ""
              dateTimeList.value = []

              let data = {
                    pageNo: requestParameters.pageNum,
                    pageSize: requestParameters.pageSize,
                    creatorId: student_s.value,
                    questionnaireId : student.value,
                    startTime: `${dateTimeList.value[0] ? dateTimeList.value[0]: '' }`,
                    endTime:  `${dateTimeList.value[1] ? dateTimeList.value[1]: '' }`,
              }
              axios.post(`${apiBaseUrl}/questionnaire/queryQuestionnaire`, data,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }, }).then(res => {
                  isReturn(res.code)
                  if(res.data.code == 200){
                     handleMessage("查询成功", 'success')
                  }
                  dataList.value = res.data.data.page.records
                  requestParameters.pageNum = res.data.data.page.current
                  requestParameters.pageSize = res.data.data.page.size
                  requestParameters.total = res.data.data.page.total
              }).catch(error => {
                  console.error(error)
              })

          }
          const addBtns = () =>{
              AddShowDlong.value = true
          }
          
          const AddexportBtns = () => {
             ShowDlongTitle.value = 'false'
             showQuestionnaireDialog.value = true
          }

          const handleSizeChange = (size) =>{
              requestParameters.pageSize = size
              let data = {
                    pageNo: requestParameters.pageNum,
                    pageSize: requestParameters.pageSize,
                    creatorId: student_s.value,
                    questionnaireId : student.value,
                    startTime: `${dateTimeList.value[0] ? dateTimeList.value[0]: '' }`,
                    endTime:  `${dateTimeList.value[1] ? dateTimeList.value[1]: '' }`,
              }
              axios.post(`${apiBaseUrl}/questionnaire/queryQuestionnaire`, data,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }, }).then(res => {
                  isReturn(res.code)
                  if(res.data.code == 200){
                     handleMessage("查询成功", 'success')
                  }
                  dataList.value = res.data.data.page.records
                  requestParameters.pageNum = res.data.data.page.current
                  requestParameters.pageSize = res.data.data.page.size
                  requestParameters.total = res.data.data.page.total
              }).catch(error => {
                  console.error(error)
              })
          }
          const handleCurrentChange = (page) =>{
              requestParameters.pageNum = page
              let data = {
                    pageNo: requestParameters.pageNum,
                    pageSize: requestParameters.pageSize,
                    creatorId: student_s.value,
                    questionnaireId : student.value,
                    startTime: `${dateTimeList.value[0] ? dateTimeList.value[0]: '' }`,
                    endTime:  `${dateTimeList.value[1] ? dateTimeList.value[1]: '' }`,
              }
              axios.post(`${apiBaseUrl}/questionnaire/queryQuestionnaire`, data,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }, }).then(res => {
                  isReturn(res.code)
                  if(res.data.code == 200){
                     handleMessage("查询成功", 'success')
                  }
                  dataList.value = res.data.data.page.records
                  requestParameters.pageNum = res.data.data.page.current
                  requestParameters.pageSize = res.data.data.page.size
                  requestParameters.total = res.data.data.page.total
              }).catch(error => {
                  console.error(error)
              })
          }
  
          const handleClickView = (boom, edible)=>{
              let { courseDate, courseEndTime, courseStartTime, subjectName } = edible
              form.student = courseStartTime
              form.student_s = courseEndTime
              form.coursecancellationStatusInput = subjectName
              form.dateTimeList = courseDate
            //   ShowDlong.value = true
              edibleRow.value = edible 
            //   sessionStorage.setItem('detailsInfo',JSON.stringify(form))


              if(boom === '编辑'){ 
                  
                  ShowDlongDisabled.value = false
                  ShowDlongTitle.value = '编辑'


                if(edible.isVacancy){

                    adminName.value = edible.creatorName
                    inputAnswering.value = edible.questionnaireNum
                    inputQuestionnaireTitle.value = edible.questionnaireTitle
                    currentTime.value = edible.createTime
                    inputQuestionnaireTitle.value = edible.questionnaireTitle
                    ShowDlongTitle.value = '编辑'



                    if(edible.contentText){
                       let jsonData_s = JSON.parse(edible.contentText)

                        console.log(jsonData_s, '111111111111111111111')

                       jsonData_s.fillInTheBlankList.forEach((itme)=>{
                            if(itme.imgUrl){
                                if(Array.isArray(itme.imgUrl)){
                                    itme.imgUrl = itme.imgUrl
                                }else{
                                    itme.imgUrl = JSON.parse(itme.imgUrl)
                                }
                            }

                            if(Array.isArray(itme.answer)){
                                itme.answer = itme.answer
                            }else{
                                itme.answer = JSON.parse(itme.answer)
                            }
                       })
                       
                       completionList.value = jsonData_s.fillInTheBlankList

                    }

                    AddexportBtnssShow.value = true

                }else{

                    ShowDlongTitle.value = '编辑'

                    if(edible.questionnaireContents){

                            let questionnaireContents = JSON.parse(edible.questionnaireContents)

                            adminName.value = edible.creatorName
                            inputAnswering.value = edible.questionnaireNum
                            inputQuestionnaireTitle.value = edible.questionnaireTitle
                            currentTime.value = edible.createTime
                            showQuestionnaireDialog.value = true


                            if(questionnaireContents.multipleChoiceList && questionnaireContents.multipleChoiceList.length > 0){
                                questionnaireAnswers.multipleChoiceList = questionnaireContents.multipleChoiceList.map((itme)=>{
                                    if(itme.questionContent){
                                        if(Array.isArray(itme.questionContent)){
                                            itme.questionContent = itme.questionContent
                                            itme.isDisplayAnswers = itme.isDisplayAnswers + ''
                                        }else{
                                            itme.questionContent = JSON.parse(itme.questionContent)
                                            itme.isDisplayAnswers = itme.isDisplayAnswers + ''
                                        }
                                    }
                                    return itme
                                })
                            }   

                            if(questionnaireContents.shortAnswerList && questionnaireContents.shortAnswerList.length > 0){
                                questionnaireAnswers.shortAnswerList = questionnaireContents.shortAnswerList.map((itme)=>{
                                    if(itme.questionContent){
                                        if(Array.isArray(itme.questionContent)){
                                            itme.questionContent = itme.questionContent
                                            itme.isDisplayAnswers = itme.isDisplayAnswers + ''
                                        }else{
                                            itme.questionContent = JSON.parse(itme.questionContent)
                                            itme.isDisplayAnswers = itme.isDisplayAnswers + ''
                                        }
                                    }
                                    return itme
                                })
                            }
                            
                            if(questionnaireContents.singleChoiceList && questionnaireContents.singleChoiceList.length > 0){
                                questionnaireAnswers.singleChoiceList = questionnaireContents.singleChoiceList.map((itme)=>{
                                    if(itme.questionContent){
                                        if(Array.isArray(itme.questionContent)){
                                            itme.questionContent = itme.questionContent
                                            itme.isDisplayAnswers = itme.isDisplayAnswers + ''
                                        }else{
                                            itme.questionContent = JSON.parse(itme.questionContent)
                                            itme.isDisplayAnswers = itme.isDisplayAnswers + ''
                                        }
                                    }
                                    return itme
                                })
                            }
                            
                        }else{
                            handleMessage("暂无答题内容", 'warning')
                        }
                }  
            }

              if(boom === '详情'){
                    
                if(edible.isVacancy){

                    adminName.value = edible.creatorName
                    inputAnswering.value = edible.questionnaireNum
                    inputQuestionnaireTitle.value = edible.questionnaireTitle
                    currentTime.value = edible.createTime
                    ShowDlongTitle.value = '方案名称详情'

                    if(edible.contentText){
                       let jsonData_s = JSON.parse(edible.contentText)
                       jsonData_s.fillInTheBlankList.forEach((itme)=>{
                            if(itme.imgUrl){
                                if(Array.isArray(itme.imgUrl)){
                                    itme.imgUrl = itme.imgUrl
                                }else{
                                    itme.imgUrl = JSON.parse(itme.imgUrl)
                                }
                            }
                           
                            if(Array.isArray(itme.answer)){
                                itme.answer = itme.answer
                            }else{
                                itme.answer = JSON.parse(itme.answer)
                            }
                       })
                       completionList.value = jsonData_s.fillInTheBlankList
                    }

                    AddexportBtnssShow.value = true

                }else{

                    ShowDlongTitle.value = '方案名称详情'
                    //   ShowDlongDisabled.value = true

                    if(edible.questionnaireContents){
                            adminName.value = edible.creatorName
                            inputAnswering.value = edible.questionnaireNum
                            inputQuestionnaireTitle.value = edible.questionnaireTitle
                            currentTime.value = edible.createTime

                            let questionnaireContents = JSON.parse(edible.questionnaireContents)
                            showQuestionnaireDialog.value = true

                            

                            if(questionnaireContents.multipleChoiceList && questionnaireContents.multipleChoiceList.length > 0){
                                questionnaireAnswers.multipleChoiceList = questionnaireContents.multipleChoiceList.map((itme)=>{
                                    if(itme.questionContent){
                                        if(Array.isArray(itme.questionContent)){
                                            itme.questionContent = itme.questionContent
                                            itme.isDisplayAnswers = itme.isDisplayAnswers + ''
                                        }else{
                                            itme.questionContent = JSON.parse(itme.questionContent)
                                            itme.isDisplayAnswers = itme.isDisplayAnswers + ''
                                        }
                                    }
                                    return itme
                                })
                            }   

                            if(questionnaireContents.shortAnswerList && questionnaireContents.shortAnswerList.length > 0){
                                questionnaireAnswers.shortAnswerList = questionnaireContents.shortAnswerList.map((itme)=>{
                                    if(itme.questionContent){
                                        if(Array.isArray(itme.questionContent)){
                                            itme.questionContent = itme.questionContent
                                            itme.isDisplayAnswers = itme.isDisplayAnswers + ''
                                        }else{
                                            itme.questionContent = JSON.parse(itme.questionContent)
                                            itme.isDisplayAnswers = itme.isDisplayAnswers + ''
                                        }
                                    }
                                    return itme
                                })
                            }
                            
                            if(questionnaireContents.singleChoiceList && questionnaireContents.singleChoiceList.length > 0){
                                questionnaireAnswers.singleChoiceList = questionnaireContents.singleChoiceList.map((itme)=>{
                                    if(itme.questionContent){
                                        if(Array.isArray(itme.questionContent)){
                                            itme.questionContent = itme.questionContent
                                            itme.isDisplayAnswers = itme.isDisplayAnswers + ''
                                        }else{
                                            itme.questionContent = JSON.parse(itme.questionContent)
                                            itme.isDisplayAnswers = itme.isDisplayAnswers + ''
                                        }
                                    }
                                    return itme
                                })
                            }
                            
                        }else{
                            handleMessage("暂无答题内容", 'warning')
                        }
                }
                 
              }
          }
  
  
          const commitCler = () =>{
              ShowDlong.value = false
              sessionStorage.setItem('detailsInfo',JSON.stringify(null))
              handleClrAll()
          }
  
          const commitAdd = (boomm) =>{
              if(boomm === 'No'){
                  ShowapprovalOpinions.value = true
              }
              if(boomm === 'Yes'){
                  ShowapprovalOpinions_Yes.value = true
              }
              ShowDlong.value = false
              handleClrAll()
          }
  
          const handleClrAll = () =>{
              form.student = ""
              form.student_s = ""
              form.coursecancellationStatusInput = []
              form.dateTimeList = ""
          }
  
          const AddcommitCler = () =>{
              AddShowDlong.value = false
              handleClerAllDing()
          }
  
          const AddcommitAdd = () =>{
              console.log(Addform, 'Addform')
              console.log(fileDataList.value, 'fileDataList')
  
  
              AddShowDlong.value = false
              // setTimeout(()=>{
              //     handleClerAllDing()
              // },2000)
          }
  
          const AddcommitSub = () =>{
              console.log(Addform, 'Addform')
              console.log(fileDataList.value, 'fileDataList')
  
  
              AddShowDlong.value = false
              // setTimeout(()=>{
              //     handleClerAllDing()
              // },2000)
          }
  
          const handleClerAllDing = () =>{
              fileDataList.value = []
              Addform.TrainName = ""
              Addform.CreatorName = ""
              Addform.TrainerName = ""
              Addform.TrainingContent = ""
              Addform.ApprovedName = ""
          }
  
          const clickitem = (itme) =>{
              console.log(itme, 'itme')
          }
  
          const handleRemove = (file, fileList) =>{
              fileDataList.value = fileList
          }
  
          const getFileName = (name) => {
               return name.substring(name.lastIndexOf("."))
          }
  
          const beforeUpload = (file, fileList) =>{
              loadingUtils.startLoading()
              const fileExtensions =
                  getFileName(file.name) === ".bmp" ||
                  getFileName(file.name) === ".tif" ||
                  getFileName(file.name) === ".gif" ||
                  getFileName(file.name) === ".pcx" ||
                  getFileName(file.name) === ".svg" ||
                  getFileName(file.name) === ".psd" ||
                  getFileName(file.name) === ".webp" ||
                  getFileName(file.name) === ".apng" ||
                  getFileName(file.name) === ".ai" ||
                  getFileName(file.name) === ".avif" ||
                  getFileName(file.name) === ".png" ||
                  getFileName(file.name) === ".pdf"||
                  getFileName(file.name) === ".mp4"||
                  getFileName(file.name) === ".excel"||
                  getFileName(file.name) === ".doc"||
                  getFileName(file.name) === ".ppt"||
                  getFileName(file.name) === ".mp3"||
                  getFileName(file.name) === ".xls"||
                  getFileName(file.name) === ".xlsx"||
                  getFileName(file.name) === ".pptx"||
                  getFileName(file.name) === ".docx"||
                  getFileName(file.name) === ".txt"||
                  getFileName(file.name) === ".jpg";
              const max20M = file.size / 1024 / 1024 < 1000;
  
              if (!fileExtensions) {
                  handleMessage("上传文件类不合格式!", 'warning')
              }
              if (!max20M) {
                  handleMessage("上传文件类不合格式!", 'warning')
              }
  
              return fileExtensions && max20M
          }
  
          const handleUpload = (option) =>{
              let obj = option.file.name
              let index = obj.lastIndexOf(".")
              obj = obj.substring(index, obj.length)
              let objName = getFileNameUUID() + getFileName(option.file.name)
              put(`mz_pc/${objName}`, option.file).then((res) => {
                  res.name = option.file.name
                  fileDataList.value.push(res)
                  loadingUtils.endLoading()
                  signatureUrl(`mz_pc/${objName}`).then((res) => {})
              });
          }
  
          const handleError = () =>{
              loadingUtils.endLoading()
          }
  
  
          const AddapprovalOpinions = () =>{
              ShowapprovalOpinions.value = false
              approvalOpinionstextarea.value = ''
              handleMessage('提交了驳回','success')
          }
  
          const approvalOpinionsCler_Yes = () => {
              ShowapprovalOpinions_Yes.value = false
              ShowDlong.value = true
              let detailsInfo = JSON.parse(sessionStorage.getItem('detailsInfo'))
              if(detailsInfo){
                 form.student = detailsInfo.student
                 form.student_s = detailsInfo.student_s
                 form.coursecancellationStatusInput = detailsInfo.coursecancellationStatusInput
                 form.dateTimeList = detailsInfo.dateTimeList
              }
          }
  
          const AddapprovalOpinions_Yes = () => {
              ShowapprovalOpinions_Yes.value = false
              handleMessage('提交了通过','success')
          }


          const showQuestionnaireDialogCler = () =>{
            
                questionnaireAnswers.singleChoiceList = [{ questionContent:[{ inputValue:'',inputOption:'' }] }]
                questionnaireAnswers.multipleChoiceList = [{ questionContent:[{ inputValue:'',inputOption:'' }] }]
                questionnaireAnswers.shortAnswerList = [{ questionContent:[{ inputValue:''}]}]

                handleClerQuestionnaireDialogAll()
          }

          const showQuestionnaireDialogAdd = () =>{

                 if(!inputQuestionnaireTitle.value){
                    handleMessage('问卷标题不能为空~','warning')
                    return
                 }else{

                    if(ShowDlongTitle.value !== '编辑'){
                        let data = { 
                            creatorId: adminNameID.value,
                            questionnaireTitle: inputQuestionnaireTitle.value,
                            questionnaireNum: inputAnswering.value,
                            contentText: JSON.stringify(questionnaireAnswers)
                        }
                        axios.post(`${apiBaseUrl}/questionnaire/addQuestionnaire`, data,{
                            headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },
                        }).then(res => {
                            isReturn(res.code)
                            if(res.data.code == 200){
                                handleMessage("添加成功", 'success')
                                handleClerQuestionnaireDialogAll()

                                let data = {
                                        pageNo: requestParameters.pageNum,
                                        pageSize: requestParameters.pageSize,
                                        creatorId: student_s.value,
                                        questionnaireId : student.value,
                                        startTime: `${dateTimeList.value[0] ? dateTimeList.value[0]: '' }`,
                                        endTime:  `${dateTimeList.value[1] ? dateTimeList.value[1]: '' }`,
                                }
                                axios.post(`${apiBaseUrl}/questionnaire/queryQuestionnaire`, data,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }, }).then(res => {
                                    isReturn(res.code)
                                    if(res.data.code == 200){
                                        handleMessage("查询成功", 'success')
                                    }
                                    dataList.value = res.data.data.page.records
                                    requestParameters.pageNum = res.data.data.page.current
                                    requestParameters.pageSize = res.data.data.page.size
                                    requestParameters.total = res.data.data.page.total
                                }).catch(error => {
                                    console.error(error)
                                })

                            }
                        }).catch(error => {
                            console.error(error)
                        })

                    }else{

                        edibleRow.value.contentText = JSON.stringify(questionnaireAnswers)
                        axios.post(`${apiBaseUrl}/questionnaire/updateQuestionnaire`, edibleRow.value,{
                            headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },
                        }).then(res => {
                            isReturn(res.code)
                            if(res.data.code == 200){
                                handleMessage("添加成功", 'success')
                                edibleRow.value = []
                                handleClerQuestionnaireDialogAll()

                                let data = {
                                        pageNo: requestParameters.pageNum,
                                        pageSize: requestParameters.pageSize,
                                        creatorId: student_s.value,
                                        questionnaireId : student.value,
                                        startTime: `${dateTimeList.value[0] ? dateTimeList.value[0]: '' }`,
                                        endTime:  `${dateTimeList.value[1] ? dateTimeList.value[1]: '' }`,
                                }
                                axios.post(`${apiBaseUrl}/questionnaire/queryQuestionnaire`, data,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }, }).then(res => {
                                    isReturn(res.code)
                                    if(res.data.code == 200){ handleMessage("查询成功", 'success')}
                                    dataList.value = res.data.data.page.records
                                    requestParameters.pageNum = res.data.data.page.current
                                    requestParameters.pageSize = res.data.data.page.size
                                    requestParameters.total = res.data.data.page.total
                                }).catch(error => {
                                    console.error(error)
                                })

                            }
                        }).catch(error => {
                            console.error(error)
                        })
                    }


                }
          }

          const handleClerQuestionnaireDialogAll = () => {
                 questionnaireAnswers.singleChoiceList = [{ questionContent:[{ inputValue:'',inputOption:'' }] }]
                 questionnaireAnswers.multipleChoiceList = [{ questionContent:[{ inputValue:'',inputOption:'' }] }]
                 questionnaireAnswers.shortAnswerList = [{ questionContent:[{ inputValue:'' }] }]
                 showQuestionnaireDialog.value = false
          }


          const handleMultipleChoiceQuestionAdd = () => {
             questionnaireAnswers.singleChoiceList.push({ questionContent:[{ inputValue:'',inputOption:'' }] })     
          }

          const handleMultipleChoiceQuestionsAdd = () => {
              questionnaireAnswers.multipleChoiceList.push({ questionContent:[{ inputValue:'',inputOption:'' }] })    
          }


          const handleMultipleChoiceQuestionsReduce = (index) => {
            if( index !== 0){
                let result = deleteByIndex(questionnaireAnswers.multipleChoiceList, index)
                questionnaireAnswers.multipleChoiceList = result
            }else{
                handleMessage('至少有一项','warning')
            }
          }


          const handleMultipleChoiceQuestionReduce = (index) => {
            if( index !== 0){
                let result = deleteByIndex(questionnaireAnswers.singleChoiceList, index)
                questionnaireAnswers.singleChoiceList = result
            }else{
                handleMessage('至少有一项','warning')
            }
          }

          const handleMultipleChoiceQuestionType = (blend,index) => {
                if(blend === 'PlusSign'){
                    questionnaireAnswers.singleChoiceList[index].questionContent.push({ inputValue:'',inputOption:'' })   
                }
                if(blend === 'MinusSign'){
                    if(questionnaireAnswers.singleChoiceList[index].questionContent.length > 1){
                        questionnaireAnswers.singleChoiceList[index].questionContent.pop()
                    }else{
                        handleMessage('至少有一项','warning')
                    }
                }
          }

          const handleMultipleChoiceQuestionsType = (blend,index) =>{
                if(blend === 'PlusSign'){
                    questionnaireAnswers.multipleChoiceList[index].questionContent.push({ inputValue:'',inputOption:'' })   
                }
                if(blend === 'MinusSign'){
                    if(questionnaireAnswers.multipleChoiceList[index].questionContent.length > 1){
                        questionnaireAnswers.multipleChoiceList[index].questionContent.pop()
                    }else{
                        handleMessage('至少有一项','warning')
                    }
                }
          }

          const handleFreeformQuestionsType = (blend,index) => {
                if(blend === 'PlusSign'){
                    questionnaireAnswers.shortAnswerList[index].questionContent.push({ inputValue:'' })   
                }
                if(blend === 'MinusSign'){
                    if(questionnaireAnswers.shortAnswerList[index].questionContent.length > 1){
                        questionnaireAnswers.shortAnswerList[index].questionContent.pop()
                    }else{
                        handleMessage('至少有一项','warning')
                    }
                }
          }

          const handleFreeformQuestionsAdd = () => {
                questionnaireAnswers.shortAnswerList.push({ questionContent:[{ inputValue:'' }] })    
          }


          const handleFreeformQuestionsReduce = (index,type) => {
            if(type === 'completionList'){
                let result = deleteByIndex(completionList.value, index)
                completionList.value = result
            }else{
                if( index !== 0){
                let result = deleteByIndex(questionnaireAnswers.shortAnswerList, index)
                    questionnaireAnswers.shortAnswerList = result
                }else{
                    handleMessage('至少有一项','warning')
                }
            }
            
          }


          const deleteByIndex = (arr, index) =>{
                arr.splice(index, 1)
                return arr
          }


          const handleBlurInputQuestionnaireTitle = () => {
                if(!inputQuestionnaireTitle.value){
                    handleMessage('请输入问卷标题','warning')
                }
          }


          const handleRegExp = (inputValue) =>{
                const regex = /[^A-Z]/g;
                let Value = inputValue.value.replace(regex, '')
                return  Value
          }


          const AddexportBtnss = () =>{
               ShowDlongTitle.value = ''
               completionList.value = []
               inputAnswering.value = ''
               inputQuestionnaireTitle.value =  ''
               AddexportBtnssShow.value = true
               ShowDlongTitle.value = ''
          }


          const AddexportBtnssShowCler = () =>{
               completionList.value = []
               inputAnswering.value = ''
               inputQuestionnaireTitle.value = ''
               AddexportBtnssShow.value = false
          }

          const handleAddAnswer = (index,type) =>{

            if(type === '删除'){
                completionList.value[index].answer.pop()
            }else{
                completionList.value[index].answer.push({ vacancyAnswer:'', vacancyScore:'' })
            }
          }

          const handleAddAnswers = () =>{
            completionList.value.push({ questionTitle:'', answer:[], imgUrl:[] })
          }

          const containsHash = (str,index) =>{
                return str.includes('#')
                
          }

          const AddexportBtnssShowAdd = () =>{

          
            completionList.value.forEach((itme)=>{

                // let replacedString = itme.questionTitle.replace(/_+/g, ",")
                // let list = []
                // let obj = {}
                // obj.text = replacedString.split(',')
                // list.push(obj)
                // itme.replacedString = list

                let list = []
                let obj = { text:[] }
                let newItime = itme.questionTitle.replace(/\n/g, '')
                let replacedString = newItime.replace(/#+/g, ',')
                list.push(replacedString)
                obj.text.push({ name: replacedString.split(',') })


                obj.text.forEach((itme)=>{
                    itme.three = []
                    if(itme.name){
                        itme.name.forEach((itmes)=>{
                            let threeNode = itmes.replace(/_+/g, ',inpit,')
                            itme.three.push(threeNode)
                        })
                    }
                })


                obj.text.forEach((itme)=>{
                    itme.threeList = []
                    if(itme.three){
                        itme.three.forEach((itmes)=>{
                            let threeNode = itmes.split(',')
                            itme.threeList.push(threeNode)
                        })
                    }
                })


                console.log(obj, '11111111111')


                // let replacedString = itme.questionTitle.replace(/_+/g, ",")
                let lists = []
                // let obj = {}
                // obj.text = replacedString.split(',')
                lists.push(obj)
                itme.replacedString = lists
                

            })


            // completionList.value.forEach((itme)=>{
            //     itme.replacedString.forEach((itme_)=>{
            //         itme_.boole = []
            //         itme_.text.forEach((itmes,index)=>{
            //             if(containsHash(itmes)){
            //                 itme_.boole.push(true)
            //             }else{
            //                 itme_.boole.push(false)
            //             }

            //         })
            //     })
            // })


            // completionList.value.forEach((itme)=>{
            //     itme.replacedString.forEach((itme_,index)=>{
            //         itme_.textS = []
            //         itme_.text.forEach((itmes)=>{
            //            itme_.textS.push(itmes.replace(/#\n+/g, ''))
            //         })
            //     })
            // })

            
            // completionList.value.forEach((itme)=>{
            //     itme.replacedString.forEach((itme_,index)=>{
            //         itme_.text = itme_.textS
            //     })
            // })


            console.log(completionList.value, 'itme_.boole.push(true)')


            completionList.value.forEach((itme)=>{
                itme.replacedString.forEach((itmes)=>{
                    itmes.input = itmes.text.length - 1
                })
            })

            completionList.value.forEach((itme)=>{
                if(itme.imgUrl){
                    itme.imgUrl = JSON.stringify(itme.imgUrl)
                }
            })


            console.log(completionList.value)


            let mapData = { fillInTheBlankList: completionList.value }
           
            if(ShowDlongTitle.value !== '编辑'){

                
                let data = { 
                    creatorId: adminNameID.value,
                    questionnaireTitle: inputQuestionnaireTitle.value,
                    questionnaireNum: inputAnswering.value,
                    contentText: JSON.stringify(mapData)
                }

                console.log(mapData,'mapDatamapDatamapDatamapDatamapData')

                axios.post(`${apiBaseUrl}/questionnaire/addQuestionnaire`, data,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },}).then(res => {
                    if(res.data.code == 200){
                        handleMessage("添加成功", 'success')
                        handleClerQuestionnaireDialogAll()
                        inputAnswering.value = ''
                        inputQuestionnaireTitle.value = ''
                        completionList.value = []
                        AddexportBtnssShow.value = false
                        let data = {
                            pageNo: requestParameters.pageNum,
                            pageSize: requestParameters.pageSize,
                            creatorId: student_s.value,
                            questionnaireId : student.value,
                            startTime: `${dateTimeList.value[0] ? dateTimeList.value[0]: '' }`,
                            endTime:  `${dateTimeList.value[1] ? dateTimeList.value[1]: '' }`,
                        }
                        axios.post(`${apiBaseUrl}/questionnaire/queryQuestionnaire`, data,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }, }).then(res => {
                            if(res.data.code == 200){
                                handleMessage("查询成功", 'success')
                            }
                                dataList.value = res.data.data.page.records
                                requestParameters.pageNum = res.data.data.page.current
                                requestParameters.pageSize = res.data.data.page.size
                                requestParameters.total = res.data.data.page.total
                            }).catch(error => {
                                console.error(error)
                            })
                        }
                    }).catch(error => {
                    console.error(error)
                })

            }else{
                edibleRow.value.contentText = JSON.stringify(mapData)
                edibleRow.value.questionnaireTitle = inputQuestionnaireTitle.value
                axios.post(`${apiBaseUrl}/questionnaire/updateQuestionnaire`, edibleRow.value,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },}).then(res => {
                    if(res.data.code == 200){
                        handleMessage("添加成功", 'success')
                        handleClerQuestionnaireDialogAll()
                        inputAnswering.value = ''
                        inputQuestionnaireTitle.value = ''
                        completionList.value = []
                        AddexportBtnssShow.value = false
                        edibleRow.value = []
                        let data = {
                            pageNo: requestParameters.pageNum,
                            pageSize: requestParameters.pageSize,
                            creatorId: student_s.value,
                            questionnaireId : student.value,
                            startTime: `${dateTimeList.value[0] ? dateTimeList.value[0]: '' }`,
                            endTime:  `${dateTimeList.value[1] ? dateTimeList.value[1]: '' }`,
                        }
                        axios.post(`${apiBaseUrl}/questionnaire/queryQuestionnaire`, data,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }, }).then(res => {
                            if(res.data.code == 200){
                                handleMessage("查询成功", 'success')
                            }   
                                dataList.value = res.data.data.page.records
                                requestParameters.pageNum = res.data.data.page.current
                                requestParameters.pageSize = res.data.data.page.size
                                requestParameters.total = res.data.data.page.total
                            }).catch(error => {
                                console.error(error)
                            })
                        }
                    }).catch(error => {
                    console.error(error)
                })

            }

          }

          const handleClickBtn = (itme,index) =>{
             console.log(itme,index)
             clickImgIndex.value = index
             showImg.value = true
          }


          const  showImgClr = () =>{
            clickImgIndex.value = 0
            showImg.value = false
          }

          const showImgAdd = () =>{
            completionList.value[clickImgIndex.value].imgUrl = [...fileDataList.value,...completionList.value[clickImgIndex.value].imgUrl]
            fileDataList.value = []
            showImg.value = false
          }

          const handleClr = (itme,index,indexs) =>{

            if(index === 0){
                completionList.value[indexs].imgUrl = []
            }else{
                completionList.value[indexs].imgUrl = completionList.value[indexs].imgUrl.splice(index, 1)
            }
          }






          return {
              showImgClr,
              showImgAdd,
              showImg,
              clickImgIndex,
              AddexportBtnssShowAdd,
              handleRegExp,
              AddexportBtnssShowCler,
              AddexportBtnssShow,
              handleBlurInputQuestionnaireTitle,
              deleteByIndex,
              handleAddAnswer,
              handleFreeformQuestionsAdd,
              handleFreeformQuestionsReduce,
              handleMultipleChoiceQuestionType,
              currentTime,
              handleClerQuestionnaireDialogAll,
              AddexportBtns,
              handleUpload,
              handleMultipleChoiceQuestionsAdd,
              handleMultipleChoiceQuestionsReduce,
              beforeUpload,
              handleError,
              getFileName,
              handleRemove,
              handleClerAllDing,
              handleClickBtn,
              fileDataList,
              clickitem,
              AddcommitCler,
              AddcommitAdd,
              commitCler,
              AddexportBtnss,
              commitAdd,
              adminNameID,
              completionList,
              handleAddAnswers,
              handleMessage,
              getStudentsArr,
              getStudentsArr_s,
              coursecancellationStatus,
              student,
              student_s,
              handleClr,
              adminName,
              containsHash,
              handleMultipleChoiceQuestionsType,
              planArr,
              coursecancellationStatusInput,
              coursecancellationStatusInput_s,
              coursecancellationStatusInput_ss,
              dateTimeList,
              handleAllApi,
              exportBtns,
              searchBtns,
              clearBtns,
              showQuestionnaireDialogCler,
              showQuestionnaireDialogAdd,
              showQuestionnaireDialog,
              addBtns,
              dataList,
              handleClickView,
              handleSizeChange,
              handleCurrentTime,
              handleCurrentChange,
              requestParameters,
              ShowDlongTitle,
              ShowDlong,
              form,
              inputQuestionnaireTitle,
              ShowDlongDisabled,
              handleClrAll,
              AddcommitSub,
              AddShowDlong,
              Addform,
              ShowapprovalOpinions,
              approvalOpinionsCler,
              approvalOpinionstextarea,
              AddapprovalOpinions,
              ShowapprovalOpinions_Yes,
              approvalOpinionsCler_Yes,
              AddapprovalOpinions_Yes,
              inputAnswering,
              questionTitle,
              edibleRow,
              score,
              inputAnswer,
              handleFreeformQuestionsType,
              questionnaireAnswers,
              handleMultipleChoiceQuestionAdd,
              handleMultipleChoiceQuestionReduce,

          }
  
      }
  
  })
  
  
</script>
  
<style scoped  lang="less">

 /deep/ .el-dialog__title{
    font-weight: 900;
 }
  
 .btns{
    background-color: #428BCA;
    border-color: #428BCA;
    color: #fff;
  }
  
  /deep/ .el-upload{
      width: 100% !important;
  }

  /deep/ .el-form-item__label{
      text-align: start;
  }
  .no-click {
    pointer-events: none;
   }

/deep/ .el-upload-dragger{
    width: 100%;
}

   .box{
        position: fixed;
        background: #f3f3f3;
        width: 100%;
        z-index: 1111;
        top: 0;
        left: 0;
        height: 100vh;
        margin: 0;
    }

    .actdiv:hover{
       border-radius: 30px;
       background: #428BCA;      
       color: #fff;
       padding: 5px 0px;
    }
  

</style>


// WEBPACK FOOTER //
// src/InitializationFile/addQuestionnaire.vue